import {
  LuLink,
  LuInstagram,
  LuTwitter,
  LuFacebook,
  LuYoutube,
  LuLinkedin,
  LuGithub,
  LuMail,
  LuPhone,
  LuMapPin,
  LuGlobe,
  LuMusic,
  LuVideo,
  LuCamera,
  LuHeart,
  LuStar,
  LuZap,
  LuShoppingCart,
  LuBookOpen,
  LuCoffee
} from 'react-icons/lu';

export const ICONS = {
  Link: LuLink,
  Instagram: LuInstagram,
  Twitter: LuTwitter,
  Facebook: LuFacebook,
  Youtube: LuYoutube,
  Linkedin: LuLinkedin,
  Github: LuGithub,
  Mail: LuMail,
  Phone: LuPhone,
  MapPin: LuMapPin,
  Globe: LuGlobe,
  Music: LuMusic,
  Video: LuVideo,
  Camera: LuCamera,
  Heart: LuHeart,
  Star: LuStar,
  Zap: LuZap,
  ShoppingCart: LuShoppingCart,
  BookOpen: LuBookOpen,
  Coffee: LuCoffee
};

export const POPULAR_ICONS = Object.keys(ICONS).map(name => ({
  name,
  icon: ICONS[name]
}));